import { render, staticRenderFns } from "./alarmHistory.vue?vue&type=template&id=66648ab0&scoped=true"
import script from "./alarmHistory.vue?vue&type=script&lang=js"
export * from "./alarmHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66648ab0",
  null
  
)

export default component.exports